import React from 'react';
import { AD_SHIELD_SCRIPT_ID, AD_SHIELD_SCRIPT_SOURCE } from './adShieldEssentialScript';

/**
 * Freestar Ad-Shield essential script.
 * Docs require a real <script> in <head> (not loaded via publisher JS wrappers).
 * Source: https://docs.ad-shield.io/public/essential-script
 */
export const FreestarAdShield: React.FC = () => (
  <script
    // eslint-disable-next-line benzinga/no-unsanitized-innerhtml -- static Ad-Shield essential payload; sanitizeHTML is for HTML and would corrupt JS
    dangerouslySetInnerHTML={{ __html: AD_SHIELD_SCRIPT_SOURCE }}
    data-cfasync="false"
    id={AD_SHIELD_SCRIPT_ID}
  />
);
